import { DispensaryV3 } from "@/custom-types/DispensariesV3";

export const getMerchId = (store: DispensaryV3, unitNameToFind: string) => {
  const merchCampaign = store.merchandisedCampaigns?.find(
    (campaign) => campaign?.unitName === unitNameToFind,
  );
  return merchCampaign?.id;
};

export const getMerchUnitName = (
  store: DispensaryV3,
  unitNameToFindById?: number,
) => {
  if (!unitNameToFindById) {
    return;
  }
  const merchCampaign = store.merchandisedCampaigns?.find(
    (campaign) => campaign?.id === unitNameToFindById,
  );
  return merchCampaign?.unitName;
};
